import { fetchCustomerDetailsGraphQL } from 'api/graphql/customerDetailsGraphQL';
import { forceLoginRedirect } from 'utils/forceLoginRedirect';

let lastCheckAt = 0;
let checkInFlight = null;

const MIN_CHECK_INTERVAL_MS = 5000;

/**
 * Confirms the current Cognito session still maps to a CustomerLogin.
 * If not (e.g. admin changed email / Cognito user recreated), force /login.
 */
export const validateCustomerSessionOrLogout = async ({ force = false } = {}) => {
  const now = Date.now();
  if (!force && now - lastCheckAt < MIN_CHECK_INTERVAL_MS) {
    return true;
  }

  if (checkInFlight) {
    return checkInFlight;
  }

  lastCheckAt = now;

  checkInFlight = (async () => {
    try {
      const details = await fetchCustomerDetailsGraphQL();
      if (!details?.id) {
        forceLoginRedirect();
        return false;
      }
      return true;
    } catch {
      // Apollo ErrorLink may also redirect; call again is safe/idempotent
      forceLoginRedirect();
      return false;
    } finally {
      checkInFlight = null;
    }
  })();

  return checkInFlight;
};
